import { render, staticRenderFns } from "./proRec.vue?vue&type=template&id=685b8919&scoped=true&"
import script from "./proRec.vue?vue&type=script&lang=js&"
export * from "./proRec.vue?vue&type=script&lang=js&"
import style0 from "./proRec.vue?vue&type=style&index=0&id=685b8919&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b8919",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,Ware: require('/app/components/ware-view/ware.vue').default})
